export enum Activity {
    Active,
    Inactive
}